import { Button, Flex, Form, Input, InputNumber } from "antd";
import { useEffect } from "react";
import CustomModal from "../../../../components/CustomModal";

interface SectionModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: { title: string; sortOrder?: number }) => void;
  mode: "create" | "update";
  initialTitle?: string;
  initialSortOrder?: number;
  loading?: boolean;
}

const SectionModal = ({
  open,
  onCancel,
  onSubmit,
  mode,
  initialTitle = "",
  initialSortOrder,
  loading = false,
}: SectionModalProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        title: initialTitle,
        sortOrder: initialSortOrder,
      });
    } else {
      form.resetFields();
    }
  }, [open, initialTitle, initialSortOrder, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
      form.resetFields();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <CustomModal
      handleClose={onCancel}
      title={mode === "create" ? "Create Section" : "Update Section"}
      open={open}
      width={560}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="custom-form"
        size="large"
        initialValues={{
          title: initialTitle,
          sortOrder: initialSortOrder,
        }}
      >
        <Form.Item
          name="title"
          label="Section Title"
          rules={[{ required: true, message: "Please enter section title" }]}
        >
          <Input placeholder="Enter section title" />
        </Form.Item>

        <Form.Item
          name="sortOrder"
          label="Sort Order"
          rules={[{ required: true, message: "Please enter sort order" }]}
        >
          <InputNumber
            min={0}
            className="w-full"
            placeholder="Enter sort order"
          />
        </Form.Item>

        <Flex justify="end" gap={8}>
          <Button disabled={loading} onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {mode === "create" ? "Create" : "Update"}
          </Button>
        </Flex>
      </Form>
    </CustomModal>
  );
};

export default SectionModal;
